export const sendEvent = (eventName, props = {}, callback = () => {}) => {
  if (typeof eventName === 'undefined' || !eventName) return callback();
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...props,
    });
    setTimeout(() => {
      return callback();
    }, 250);
  } catch (err) {
    console.log(err);
  }
};
